const ns = "SNACKBAR";
export const SHOW = `${ns}_SHOW`;
export const HIDE = `${ns}_HIDE`;
